
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "c0f0115d-0291-4c30-9dbd-8f60d1fd3dc1"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
